function EgressIpsCtrl($scope,$controller,$location,$timeout){
	$scope.accountIDsForRemoveRPF = "";

	$scope.popsConfig = {
        dataURL : function(){
            return "/allPublicIPs"
        },
        noSearch: true,
        fields : [
            {"label":"Location","path":"name","template":"<span>{{item.name}}</span>"},
            {"label":"# of Pops","path":"popNum","template":"<span>{{item.popNum}}</span>"},
            {"label":"Purchased","path":"totalIps","template":"<span>{{item.totalIps}}</span>"},
			{"label":"Allocated","path":"takenIps","template":"<span>{{item.takenIps}}</span>"},
			{"label":"Reserved","path":"takenIps","template":"<span>{{item.reservedIps}}</span>"},
            {"label":"Available","path":"takenIps","template":"<span>{{item.totalIps - item.takenIps - item.reservedIps}} ({{((item.totalIps - item.takenIps - item.reservedIps)/item.totalIps) * 100 | number : 2}}%)</span>"}
       ],
       actions: []
    };

	$scope.usedIPsConfig = {
        dataURL : function() {
            return "/allUsedIPs" + ($scope.accountId ? "?accountId=" + $scope.accountId : "");
        },
        fields : [
            {"label":"Account Id","path":"accountId","template":"<span>{{item.accountId}}</span>"},
            {"label":"Account Name","path":"accountName","template":"<span>{{item.accountName}}</span>"},
            {"label":"IP","path":"ip","template":"<span>{{item.ip}} ({{tableConfig.locationNames[item.locationId]}})</span>"},
            {"label":"License", "path":"license","template":"<span>{{item.license}}</span>"},
            {"label":"Usages","path":"usages","template":"<span>{{item.usages}}</span>"}
        ],
        noSearch: false,
        sortList: [],
        searchFields: ["accountName", "ip", "usages", "locationId"],
        actions: [],
        pageSize: 50
    };

    $scope.graceConfig = {
        dataURL : function(){
            if ($scope.accountId){
                return "/allGracePublicIPs?accountId=" + $scope.accountId;
            }else{
                return "/allGracePublicIPs";
            }
        },
        noSearch: true,
        fields : [
            {"label":"Account Id","path":"id","template":"<span>{{item.account_id}}</span>"},
            {"label":"Account Name","path":"accountName","template":"<span>{{item.accountName}}</span>"},
            {"label":"Pop Id","path":"popId","template":"<span>{{item.popId}}</span>"},
            {"label":"Pop Location","path":"locationId","template":"<span>{{item.locationId}}</span>"},
            {"label":"IP","path":"ip","template":"<span>{{item.ip}}</span>"},
            {"label":"Creation Date","path":"creationDate","template":"<span>{{item.creationDate}}</span>"}
        ],
        type : "AllocatedIpGraceTime",
        sortList: ["account_id"],
        actions: ["remove"],
        selectedItems: [],
        clientSideSort: true,
        clientSideSearch: false,
        clientSidePaging: true,
        pageSize: 10,
		customDelete: true,
		removeURL: function removeURL() {
			return 'removeGraceIp';
		},
    };

    var loadLocations = function(){
	    store.fetch({
	        path: "/getlocations",
	        success: function(data) {
				var byId = data.reduce(function(map, obj) {
					map[obj.id] = obj.name;
					return map;
				}, {});
	            $scope.usedIPsConfig.locationNames = byId;
	        }
    	});
    };

    loadLocations();

	$scope.sanityTestPublicIps = function() {

		$scope.searchResponse = {info: "Sending Request..."};

		// build URL
		var url = "/ag/publicIpsSanity?authenticityToken=" + authenticityToken;

		// Send request
		store.fetch({
			method : 'POST',
			url : url ,
			success: function(data) {
				$scope.searchResponse = data;
			},
			error: function() {
				$scope.searchResponse.info = "Bad Request";
			}
		});
	};

    $scope.sanityTestPublicIps = function() {

    		$scope.searchResponse = {info: "Sending Request..."};

    		// build URL
    		var url = "/ag/publicIpsSanity?authenticityToken=" + authenticityToken;

    		// Send request
    		store.fetch({
    			method : 'POST',
    			url : url ,
    			success: function(data) {
    				$scope.searchResponse = data;
    			},
    			error: function() {
    				$scope.searchResponse.info = "Bad Request";
    			}
    		});
    	};

	$scope.clearAllocatedIps = function() {

		$scope.searchResponse = {info: "Sending Request..."};

		// build URL
		var url = "/ag/clearAllocatedIps?authenticityToken=" + authenticityToken;

		// Send request
		store.fetch({
			method : 'POST',
			url : url ,
			success: function(data) {
				$scope.searchResponse = data;
			},
			error: function() {
				$scope.searchResponse.info = "Bad Request";
			}
		});
	};

	$scope.removeNotAllocatedGlobalRPF = function() {

		$scope.searchResponse = {info: "Sending Request..."};

		// Send request
		store.fetch({
			method : 'POST',
			url : "/ag/removeNotAllocatedGlobalRPF",
			queryParams: {
				'accountIdsRaw': $scope.accountIDsForRemoveRPF
			},
			success: function(data) {
				$scope.searchResponse = data;
			},
			error: function() {
				$scope.searchResponse.info = "Bad Request";
			}
		});
	};
}
